import React from "react";
import "./MedicalTourism2.css";

const helpData = [
  {
    image: "/assets/help1.png",
    title: "Complete Travel Support",
    description:
      "Flights, visas, stay, and local transport arranged around your treatment schedule.",
  },
  {
    image: "/assets/help2.png",
    title: "Patient First Care",
    description:
      "Every recommendation is filtered through what's right for you, not for us.",
  },
  {
    image: "/assets/help3.png",
    title: "Affordable Healthcare",
    description:
      "Negotiated hospital rates and transparent packages with no hidden fees.",
  },
  {
    image: "/assets/help4.png",
    title: "Expert Doctor Matching",
    description:
      "Paired with specialists whose exact expertise fits your diagnosis.",
  },
];

const MedicalTourism2 = () => {
  return (
    <section className="help-section standard-padding">

      <h1 className="heading help-heading">
        How Do We Help You
      </h1>

      <div className="help-grid">
        {helpData.map((item, index) => (
          <div className="help-card" key={index}>

            <div className="help-image">
              <img src={item.image} alt={item.title} />
            </div>

            <div className="help-content">
              <h3>{item.title}</h3>

              <p>{item.description}</p>
            </div>

          </div>
        ))}
      </div>

    </section>
  );
};

export default MedicalTourism2;